import React from 'react';

import { Spacer } from '@packages/ui';
import { Product, DeviceType, ClickoutSegment } from '@packages/common';
import {
  WishlistHelperContext,
  ImpressionTracker,
  ClickoutProvider,
  ProductCarousel,
  Clickout,
} from '@packages/shared';

import { RecoTile } from '../../../RecoTile';

interface CMSSliderProps {
  hits: Product[];
  deviceType: DeviceType;
  categoryId?: string;
}

const CMSSlider: React.FC<CMSSliderProps> = ({ hits, categoryId }) => {
  const { wishlistHelper } = React.useContext(WishlistHelperContext);

  return (
    <ClickoutProvider segment={ClickoutSegment.CONTENT} service="content">
      <Spacer mt={[0, 2, 4]}></Spacer>
      <ProductCarousel
        categoryId={categoryId}
        centered={[true, true, false]}
        slidesToShow={[2, 3, 4, 4, 5]}
        slides={hits.map((product, index) => {
          return (
            <Spacer p={[2]} key={`product-${index}-${product.objectID}`}>
              <ImpressionTracker product={product} index={index}>
                <RecoTile
                  Clickout={Clickout}
                  index={index}
                  wishlistHelper={wishlistHelper}
                  key={`reco-tile-${index}-${product.objectID}`}
                  product={product}
                />
              </ImpressionTracker>
            </Spacer>
          );
        })}
      />
    </ClickoutProvider>
  );
};

export default CMSSlider;
